/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { barredLocationSchema } from './barred-location-schema';
import { calendarSchema } from './calendar-schema';
import { candidateIndustrySchema } from './candidate-industry-schema';
import { candidateLanguageSchema } from './candidate-language-schema';
import { candidateLegalTechnicalSkillSchema } from './candidate-legal-technical-skill-schema';
import { candidateOppFeedAlertSchema } from './candidate-opp-feed-alert-schema';
import { candidateOpportunitySchema } from './candidate-opportunity-schema';
import { candidateReputationSchema } from './candidate-reputation-schema';
import { candidatesSavedOpportunitySchema } from './candidates-saved-opportunity-schema';
import { certificationSchema } from './certification-schema';
import { educationSchema } from './education-schema';
import { experienceSchema } from './experience-schema';
import { homeOfficeSchema } from './home-office-schema';
import { opportunitySchema } from './opportunity-schema';
import { tagSchema } from './tag-schema';
import { userSchema } from './user-schema';
import { BusinessTitle, ContactMethod, CountryCode, CurrencyCode, DayOfWeek, EmployeeType, EmploymentStatus, FocusArea, FrequencyType, LawyerType, NotificationType, PracticeAreaEnum, ProfileStatus, Pronouns, YesNo } from "../enums";
export const candidateSchema: z.AnyZodObject = z.object({
  accounts: z.array(z.lazy(() => accountSchema)).nullish(),
  address1: z.string().nullish(),
  address2: z.string().nullish(),
  addressCity: z.string().nullish(),
  addressCountry: z.string().nullish(),
  addressCountryCode: z.nativeEnum(CountryCode).nullish(),
  addressState: z.string().nullish(),
  addressZip: z.string().nullish(),
  alphabeticallySmallestEngagementAccountName: z.string().nullish(),
  alphabeticallySmallestEngagementEndDate: z.string().date().nullish(),
  alphabeticallySmallestEngagementEndDateStatus: z.string().nullish(),
  availabilityNotes: z.string().nullish(),
  availabilityPreferencesUpdatedAt: z.string().datetime().nullish(),
  availabilityPreferencesUpdatedBy: z.string().uuid().nullish(),
  availabilityPreferencesUpdatedByUser: z.lazy(() => userSchema).nullish(),
  averageAdHocHoursWeekly: z.number().int().nullish(),
  axiomEmployeeType: z.string().nullish(),
  barredLocations: z.array(z.lazy(() => barredLocationSchema)).nullish(),
  baseAnnualSalary: z.number().nullish(),
  bonusPercentage: z.number().nullish(),
  bullhornId: z.string().nullish(),
  businessTitle: z.nativeEnum(BusinessTitle).nullish(),
  calendar: z.lazy(() => calendarSchema).nullish(),
  candidateHeader: z.string().nullish(),
  candidateHeaderUpdatedAt: z.string().datetime().nullish(),
  candidateOpportunities: 
    z.array(z.lazy(() => candidateOpportunitySchema))
  .nullish(),
  candidateOpportunityFeedAlert: 
    z.lazy(() => candidateOppFeedAlertSchema)
  .nullish(),
  candidateReputation: z.lazy(() => candidateReputationSchema).nullish(),
  candidateSummary: z.string().nullish(),
  candidateSummaryUpdatedAt: z.string().datetime().nullish(),
  candidatesSavedOpportunities: 
    z.array(z.lazy(() => candidatesSavedOpportunitySchema))
  .nullish(),
  certifications: z.array(z.lazy(() => certificationSchema)).nullish(),
  collaborators: z.array(z.lazy(() => userSchema)).nullish(),
  communicationAlerts: 
    z.object({
      axiomAnnouncements: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      engagementStatus: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      interviews: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      lessonlyReminderCommunications: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      opportunityFeed: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      opportunitySuggestions: 
        z.object({
          notificationType: z.nativeEnum(NotificationType).nullish(),
        })
      .nullish(),
      submissionStatus: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      talentPartnerCommunications: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
        })
      .nullish(),
      timesheets: 
        z.object({
          optInEmail: z.boolean().nullish(),
          optInTextMessage: z.boolean().nullish(),
          timeSensitivePreferences: 
            z.object({
              dayOfWeek: z.array(z.nativeEnum(DayOfWeek)).nullish(),
              frequency: z.array(z.nativeEnum(FrequencyType)).nullish(),
              timeOfDay: z.string().nullish(),
            })
          .nullish(),
        })
      .nullish(),
    })
  .nullish(),
  compHourly40hr: z.number().nullish(),
  compHourlyPremium: z.number().nullish(),
  compensation: z.number().nullish(),
  counselWorkPreference: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  crossFulfilled: z.boolean(),
  currencyType: z.nativeEnum(CurrencyCode).nullish(),
  currentAvailabilityUpdatedAt: z.string().date().nullish(),
  daysDesiredRemote: z.number().int().nullish(),
  daysRequiredRemote: z.number().int().nullish(),
  degrees: z.array(z.lazy(() => educationSchema)).nullish(),
  desiredCommute: z.nativeEnum(YesNo).nullish(),
  desiredEngagementSpecificCompensation: z.nativeEnum(YesNo).nullish(),
  desiredHoursUpdatedAt: z.string().datetime().nullish(),
  desiredWeeklyMaxHours: z.number().nullish(),
  displayFirstName: z.string().nullish(),
  displayHighHourlyRate: z.number().nullish(),
  displayLastName: z.string().nullish(),
  displayLowHourlyRate: z.number().nullish(),
  displayWeeklyRate: z.number().nullish(),
  employeeType: z.nativeEnum(EmployeeType).nullish(),
  employmentStatus: z.nativeEnum(EmploymentStatus).nullish(),
  experiences: z.array(z.lazy(() => experienceSchema)).nullish(),
  firstName: z.string().nullish(),
  flaggedAt: z.string().nullish(),
  flaggedBy: z.string().uuid().nullish(),
  focusAreaOrdering: 
    z.object({
      hiddenFocusAreas: z.array(z.nativeEnum(FocusArea)).nullish(),
      topFocusAreas: z.array(z.nativeEnum(FocusArea)).nullish(),
    })
  .nullish(),
  furthestCandidacyStatus: z.string().nullish(),
  furthestCandidacyStatusUpdatedAt: z.string().datetime().nullish(),
  homeOffice: z.lazy(() => homeOfficeSchema).nullish(),
  homeOfficeId: z.string().uuid().nullish(),
  homePhone: z.string().nullish(),
  hourlyCompensation: z.number().nullish(),
  hourlyPrice10hrReserved: z.number().nullish(),
  hourlyPrice10hrReservedLawFirm: z.number().nullish(),
  hourlyPrice20hrReserved: z.number().nullish(),
  hourlyPrice20hrReservedLawFirm: z.number().nullish(),
  hourlyPrice30hrReserved: z.number().nullish(),
  hourlyPrice30hrReservedLawFirm: z.number().nullish(),
  hourlyPrice40hrReserved: z.number().nullish(),
  hourlyPrice40hrReservedLawFirm: z.number().nullish(),
  hourlyPriceVariable: z.number().nullish(),
  hourlyPriceVariableLawFirm: z.number().nullish(),
  hoursPerDay: z.number().nullish(),
  id: z.string().uuid(),
  industries: z.array(z.lazy(() => candidateIndustrySchema)).nullish(),
  integrationId: z.string().nullish(),
  interviewAvailabilityOutdated: z.boolean(),
  interviewAvailabilityReminderSentAt: z.string().datetime().nullish(),
  isFlagged: z.boolean().nullish(),
  isOpenToAdHoc: z.boolean().nullish(),
  isOpenToCommute: z.boolean().nullish(),
  isOpenToFullTime: z.boolean().nullish(),
  isOpenToMultipleClients: z.boolean().nullish(),
  isOpenToOtherWork: z.boolean().nullish(),
  isOpenToPartTime: z.boolean().nullish(),
  isOpenToRemote: z.boolean().nullish(),
  isOptInWorkFeedEmail: z.boolean().nullish(),
  isProfileShared: z.boolean(),
  isSpotlightedLawyer: z.boolean().nullish(),
  languages: z.array(z.lazy(() => candidateLanguageSchema)).nullish(),
  lastName: z.string().nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  latestEngagementAccountName: z.string().nullish(),
  latestEngagementEndDate: z.string().date().nullish(),
  lawSchool: z.string().nullish(),
  lawSchoolId: z.string().uuid().nullish(),
  legalTechnicalSkills: 
    z.array(z.lazy(() => candidateLegalTechnicalSkillSchema))
  .nullish(),
  loginEmail: z.string().nullish(),
  maxHours: z.number().nullish(),
  middleName: z.string().nullish(),
  minWeeklyHoursPerPosition: z.number().int().nullish(),
  mobilePhone: z.string().nullish(),
  noticePeriod: z.string().nullish(),
  openToLargeProjects: z.boolean(),
  openToLawFirms: z.boolean(),
  openToPermanentPlacement: z.boolean(),
  openToSecondment: z.boolean(),
  openToVariableHourlyProjects: z.boolean(),
  oppAlertsMessageDismissed: z.boolean(),
  ownerUser: z.lazy(() => userSchema).nullish(),
  ownerUserId: z.string().uuid().nullish(),
  partTimeHoursFri: z.number().int().nullish(),
  partTimeHoursMon: z.number().int().nullish(),
  partTimeHoursThu: z.number().int().nullish(),
  partTimeHoursTue: z.number().int().nullish(),
  partTimeHoursWed: z.number().int().nullish(),
  personalEmail: z.string().nullish(),
  practiceStartYear: z.number().int().nullish(),
  preferredContactMethod: z.nativeEnum(ContactMethod).nullish(),
  previousProfileStatus: z.string().nullish(),
  pricingCurrency: z.string().nullish(),
  primaryFocusArea: z.nativeEnum(FocusArea).nullish(),
  primaryPracticeArea: z.nativeEnum(PracticeAreaEnum).nullish(),
  priorityTalent: z.boolean(),
  profileImageKey: z.string().nullish(),
  profileImageName: z.string().nullish(),
  profileStatus: z.nativeEnum(ProfileStatus).nullish(),
  profileStatusLastUpdatedBy: z.string().uuid().nullish(),
  profileStatusLastUpdatedByUser: z.lazy(() => userSchema).nullish(),
  profileStatusUpdatedAt: z.string().datetime().nullish(),
  profileVisibilityPreferencesReviewedBy: z.string().uuid().nullish(),
  profileVisibilityReviewedAt: z.string().datetime().nullish(),
  programsPreferencesReviewedAt: z.string().datetime().nullish(),
  programsPreferencesReviewedBy: z.string().uuid().nullish(),
  pronouns: z.nativeEnum(Pronouns).nullish(),
  publicRefId: z.number().int(),
  resume: z.string().nullish(),
  rewardsPlan: z.string().nullish(),
  savedOpportunities: z.array(z.lazy(() => opportunitySchema)).nullish(),
  searchableByClient: z.boolean().nullish(),
  settings: 
    z.object({
      lawyerSpecificType: 
        z.array(
          z.object({
            countryCode: z.nativeEnum(CountryCode).nullish(),
            type: z.array(z.nativeEnum(LawyerType)).nullish(),
          })
        )
      .nullish(),
    })
  .nullish(),
  showReputation: z.boolean().nullish(),
  soonestEngagementAccountName: z.string().nullish(),
  soonestEngagementEndDate: z.string().date().nullish(),
  soonestEngagementEndDateStatus: z.string().nullish(),
  suggestPhotoDismissedAt: z.string().datetime().nullish(),
  tags: z.array(z.lazy(() => tagSchema)).nullish(),
  terminationDate: z.string().date().nullish(),
  terminationReason: z.string().nullish(),
  timezone: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  weeklyAvailability: z.number().nullish(),
  weeklyPriceFullTime: z.number().nullish(),
  weeklyPriceFullTimeLawFirm: z.number().nullish(),
  workEmail: z.string().nullish(),
  workStylePreferencesReviewedAt: z.string().datetime().nullish(),
  workStylePreferencesReviewedBy: z.string().uuid().nullish(),
});

export type Candidate = z.infer<typeof candidateSchema>;
